<div class="modal-wrapper">
  <ion-header class="ion-no-border premium-header">
    <div class="header-curve"></div>
    <div class="custom-toolbar">
      <div class="toolbar-content">
        <div class="icon-btn" (click)="close()">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </div>
        <div class="title-group">
          <div class="title-main">{{ mode === 'add' ? 'Nuevo Trabajo' : 'Editar Trabajo' }}</div>
        </div>
      </div>
    </div>
  </ion-header>

  <!-- Apply specific structure for flex layout -->
  <ion-content class="modal-content" [scrollY]="true">

    <div class="layout-wrapper">
      <div class="steps-container">
        <div class="step-indicator" [class.active]="currentStep >= 1">1</div>
        <div class="step-line" [class.active]="currentStep >= 2"></div>
        <div class="step-indicator" [class.active]="currentStep >= 2">2</div>
        <div class="step-line" [class.active]="currentStep >= 3"></div>
        <div class="step-indicator" [class.active]="currentStep >= 3">3</div>
      </div>

      <div class="slides-container">

        <!-- STEP 1: Basic Info -->
        <div class="slide-section" *ngIf="currentStep === 1">
          <div class="slide-header">
            <h3>Información Básica</h3>
            <p>Datos generales del proyecto</p>
          </div>

          <div class="form-card">
            <!-- SOLICITANTE -->
            <div class="input-group">
              <label><ion-icon name="people-outline"></ion-icon> Solicitante <span class="req">*</span></label>
              <div class="autocomplete-wrapper">
                <div class="premium-input-wrapper" [class.active-dropdown]="showSolicitanteDropdown">
                  <input class="ac-input" type="text" [(ngModel)]="formData.solicitante"
                    (input)="filterSolicitantes($event)" (focus)="filterSolicitantes($event)"
                    placeholder="Escribe para buscar...">
                  <ion-icon name="close-circle" class="ac-clear" *ngIf="formData.solicitante"
                    (click)="clearSolicitante()"></ion-icon>
                </div>
                <div class="ac-dropdown" *ngIf="showSolicitanteDropdown">
                  <div class="ac-item" *ngFor="let s of filteredSolicitantes" (click)="selectSolicitante(s)">
                    <ion-icon name="person-outline"></ion-icon>
                    {{ s.nombre }}
                  </div>
                  <div class="ac-item ac-create" *ngIf="formData.solicitante && !doesSolicitanteExist(formData.solicitante)" (click)="createSolicitante()">
                    <ion-icon name="add-circle-outline"></ion-icon>
                    Crear "{{ formData.solicitante }}"
                  </div>
                </div>
              </div>
              <div class="error-hint"
                *ngIf="formData.solicitante && !selectedSolicitanteId && !showSolicitanteDropdown">
                <ion-icon name="alert-circle-outline"></ion-icon>
                <span>Este solicitante no existe, debes crearlo.</span>
              </div>
              <div class="selected-chip" *ngIf="selectedSolicitanteId && !showSolicitanteDropdown">
                <ion-icon name="checkmark-circle"></ion-icon>
                {{ formData.solicitante }}
              </div>
            </div>

            <!-- CLIENTE -->
            <div class="input-group">
              <label><ion-icon name="person-outline"></ion-icon> Cliente <span class="req">*</span></label>
              <div class="autocomplete-wrapper">
                <div class="premium-input-wrapper" [class.active-dropdown]="showClienteDropdown">
                  <input class="ac-input" type="text" [(ngModel)]="formData.cliente" (input)="filterClientes($event)"
                    (focus)="filterClientes($event)" placeholder="Escribe para buscar...">
                  <ion-icon name="close-circle" class="ac-clear" *ngIf="formData.cliente"
                    (click)="clearCliente()"></ion-icon>
                </div>
                <div class="ac-dropdown" *ngIf="showClienteDropdown">
                  <div class="ac-item" *ngFor="let c of filteredClientes" (click)="selectCliente(c)">
                    <ion-icon name="person-circle-outline"></ion-icon>
                    {{ c.nombre }}
                  </div>
                  <div class="ac-item ac-create" *ngIf="formData.cliente && !doesClienteExist(formData.cliente)" (click)="createCliente()">
                    <ion-icon name="add-circle-outline"></ion-icon>
                    Crear "{{ formData.cliente }}"
                  </div>
                </div>
              </div>
              <div class="error-hint" *ngIf="formData.cliente && !selectedClienteId && !showClienteDropdown">
                <ion-icon name="alert-circle-outline"></ion-icon>
                <span>Este cliente no existe, debes crearlo.</span>
              </div>
              <div class="selected-chip" *ngIf="selectedClienteId && !showClienteDropdown">
                <ion-icon name="checkmark-circle"></ion-icon>
                {{ formData.cliente }}
              </div>
            </div>

            <!-- LUGAR (Dirección) -->
            <div class="input-group">
              <label>
                <ion-icon name="location-outline"></ion-icon>
                Lugar / Dirección <span class="req">*</span>
                <span class="ac-hint" style="margin-left: auto; font-size: 0.7rem; opacity: 0.6;"
                  *ngIf="!selectedClienteId">(Selecciona cliente primero)</span>
              </label>
              <div class="autocomplete-wrapper">
                <div class="premium-input-wrapper" [class.active-dropdown]="showDireccionDropdown"
                  [class.readonly-row]="!selectedClienteId">
                  <input class="ac-input" type="text" [(ngModel)]="formData.lugar" (input)="filterDirecciones($event)"
                    (focus)="filterDirecciones($event)" [disabled]="!selectedClienteId"
                    placeholder="Escribe para buscar...">
                  <ion-icon name="close-circle" class="ac-clear" *ngIf="formData.lugar"
                    (click)="clearDireccion()"></ion-icon>
                </div>
                <div class="ac-dropdown" *ngIf="showDireccionDropdown">
                  <div class="ac-item" *ngFor="let d of filteredDirecciones" (click)="selectDireccion(d)">
                    <ion-icon name="location-outline"></ion-icon>
                    {{ d.nombre }}
                  </div>
                  <div class="ac-item ac-create" *ngIf="formData.lugar && !doesDireccionExist(formData.lugar)" (click)="createDireccion()">
                    <ion-icon name="add-circle-outline"></ion-icon>
                    Agregar nueva dirección
                  </div>
                </div>
              </div>
              <div class="error-hint" *ngIf="formData.lugar && !selectedDireccionId && !showDireccionDropdown">
                <ion-icon name="alert-circle-outline"></ion-icon>
                <span>Esta dirección no existe, debes crearla.</span>
              </div>
              <div class="selected-chip" *ngIf="selectedDireccionId && !showDireccionDropdown">
                <ion-icon name="checkmark-circle"></ion-icon>
                {{ formData.lugar }}
              </div>
            </div>

            <!-- Incluye Material Toggle (Premium Chip Style) -->
            <div class="premium-chip-container" style="margin-top: 20px; border: 1px solid #f1f5f9;">
              <ion-icon name="hammer-outline"></ion-icon>
              <span>¿Incluye materiales por nosotros?</span>
              <ion-toggle [(ngModel)]="formData.incluyeMaterial" color="danger" slot="end"
                class="toggle-premium-red"></ion-toggle>
            </div>
          </div>
        </div>

        <!-- STEP 2: Items / Detalles -->
        <div class="slide-section flex-slide" *ngIf="currentStep === 2">
          <div class="slide-header">
            <h3>Detalles del Trabajo</h3>
            <p>Describe las tareas a realizar</p>
          </div>

          <div class="form-card" style="margin-bottom: 16px;">
            <!-- Row for Medida and Cantidad -->
            <div class="grid-inputs">
              <div class="input-group">
                <label><ion-icon name="construct-outline"></ion-icon> Medida</label>
                <div class="autocomplete-wrapper">
                  <div class="premium-input-wrapper select-preview" (click)="toggleMedidaDropdown()"
                    [class.active-dropdown]="showMedidaDropdown">
                    <div class="selected-value">{{ getMedidaLabel(currentItem.medida) }}</div>
                    <ion-icon name="chevron-down-outline" class="ac-dropdown-icon"></ion-icon>
                  </div>
                  <div class="ac-dropdown" *ngIf="showMedidaDropdown" style="display: block;">
                    <div class="ac-item" *ngFor="let opt of tipoMedidaOptions" (click)="selectMedida(opt.value)">
                      <ion-icon name="construct-outline"></ion-icon>
                      {{ opt.label }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="input-group">
                <label><ion-icon name="calculator-outline"></ion-icon> Cantidad</label>
                <div class="premium-input-wrapper">
                  <input type="number" placeholder="0.00" [(ngModel)]="currentItem.cantidad">
                </div>
              </div>
            </div>

             <!-- Improved Descripcion Textarea -->
             <div class="input-group full">
               <div class="label-row">
                 <label><ion-icon name="document-text-outline"></ion-icon> Descripción</label>
                 <ion-button size="small" fill="clear" class="ai-button" (click)="mejorarDescripcionConIA()" [disabled]="isImprovingDesc">
                   <ion-icon name="sparkles-outline" slot="start" *ngIf="!isImprovingDesc"></ion-icon>
                   <ion-spinner name="crescent" *ngIf="isImprovingDesc" slot="start"></ion-spinner>
                   {{ isImprovingDesc ? aiAttemptStatus : 'Mejorar con IA' }}
                 </ion-button>
               </div>
               <div class="premium-input-wrapper">
                 <textarea class="custom-textarea" placeholder="Describe el item..."
                   [(ngModel)]="currentItem.descripcion" rows="2"></textarea>
               </div>
               
               <!-- Alternador de versión IA vs Original -->
               <div class="ai-toggle-container" *ngIf="selectedDescMode">
                 <div class="ai-toggle-row">
                   <button type="button" class="ai-toggle-btn" [class.active]="selectedDescMode === 'original'" (click)="toggleDescMode('original')">
                     Ver versión original
                   </button>
                   <button type="button" class="ai-toggle-btn" [class.active]="selectedDescMode === 'ai'" (click)="toggleDescMode('ai')">
                     Ver versión IA
                   </button>
                 </div>
               </div>
             </div>

            <div class="buttons-row align-end" style="margin-top: 10px;">
              <ion-button expand="block" fill="solid" (click)="addItem()" class="premium-fab"
                style="width: 100%; margin: 0;">
                <ion-icon [name]="isEditingItem ? 'create-outline' : 'add-circle-outline'" slot="start"></ion-icon>
                <span>{{ isEditingItem ? 'Modificar Item' : 'Agregar Item' }}</span>
              </ion-button>
            </div>
          </div>

          <!-- List of added items -->
          <div class="items-list" *ngIf="items.length > 0">
            <div class="items-header">Items Agregados ({{items.length}})</div>
            <div class="item-chip" *ngFor="let item of items; let i = index">
              <div class="item-info">
                <span class="item-qty">{{item.cantidad}} {{item.medida}}</span>
                <span class="item-desc">{{item.descripcion || 'Sin descripción'}}</span>
              </div>
              <div class="item-actions">
                <ion-icon name="create-outline" style="color: #2a5298;" (click)="editItem(i)"></ion-icon>
                <ion-icon name="trash-outline" color="danger" (click)="removeItem(i)"></ion-icon>
              </div>
            </div>
          </div>
        </div>

        <!-- STEP 3: Summary -->
        <div class="slide-section" *ngIf="currentStep === 3">
          <div class="slide-header">
            <h3>Resumen Final</h3>
            <p>Verifica los datos antes de guardar</p>
          </div>

          <div class="form-card">
            <div class="summary-group">
              <p><strong>Solicitante:</strong> <span>{{formData.solicitante || '-'}}</span></p>
              <p><strong>Cliente:</strong> <span>{{formData.cliente || '-'}}</span></p>
              <p><strong>Lugar:</strong> <span>{{formData.lugar || '-'}}</span></p>
              <p><strong>¿Incluye materiales?:</strong> <span>{{formData.incluyeMaterial ? 'Sí' : 'No'}}</span></p>
            </div>

            <div class="summary-items-list" style="margin-top: 16px;">
              <p>Detalle de Items ({{items.length}})</p>
              <div class="summary-item" *ngFor="let item of items">
                <span class="qty">{{item.cantidad}} {{item.medida}}</span>
                <span class="desc">{{item.descripcion}}</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </ion-content>

  <div class="form-footer-actions" *ngIf="!isKeyboardVisible">
    <!-- Botón Atrás / Cancelar -->
    <ion-button (click)="prevStep()" [disabled]="currentStep === 1" fill="outline" class="cancel-modal-btn">
      <ion-icon name="arrow-back-outline" slot="start"></ion-icon>
      Atrás
    </ion-button>

    <!-- Botón Siguiente / Guardar -->
    <ion-button (click)="currentStep < 3 ? nextStep() : save()" class="save-btn" [disabled]="isSaving">
      <span *ngIf="!isSaving">{{ currentStep < 3 ? 'Siguiente' : 'Guardar Trabajo' }}</span>
          <ion-icon *ngIf="!isSaving" [name]="currentStep < 3 ? 'arrow-forward-outline' : 'checkmark-done-outline'"
            slot="end"></ion-icon>
          <ion-spinner name="crescent" color="light" *ngIf="isSaving" slot="end"></ion-spinner>
    </ion-button>
  </div>
</div>